<flowaccount-shopee-lazada-intro></flowaccount-shopee-lazada-intro>

<flowaccount-multi-shop-banner></flowaccount-multi-shop-banner>

<flowaccount-shopee-lazada-benefit></flowaccount-shopee-lazada-benefit>

<flowaccount-shopee-lazada-video></flowaccount-shopee-lazada-video>

<flowaccount-shopee-lazada-video-online></flowaccount-shopee-lazada-video-online>

<flowaccount-blog-swiper-squidex
  [customHeader]="{
    heading: 'BLOG_SWIPER_TOPIC.HEADING_SHOPEE-LAZADA',
    detail: 'BLOG_SWIPER_TOPIC.DETAIL_SHOPEE-LAZADA',
  }
"
  [contentSquidex]="'shopeelazada-blog'"
  [contentScully]="'shopeelazada-blog-key'"
></flowaccount-blog-swiper-squidex>

<ng-container *ngIf="translate.currentLang === 'th'">
  <flowaccount-faq-accordion-squidex
    [contentSquidex]="'shopee-lazada-faq'"
    [contentScully]="'shopee-lazada-faq-key'"
  ></flowaccount-faq-accordion-squidex>
</ng-container>
